import { useState } from "react";
import { P, FF, inputBase } from "../../styles/tokens";
import { fmt, sum } from "../../utils/format";
import { CATS } from "../../constants/categories";
import { Card, Heading, EmptyState } from "../ui";
import MoneyInput from "../inputs/MoneyInput";

export default function PresupuestosView({ presupuestos, setPresupuestos, data, activeMonth, categorias }) {
  const [confirmingId, setConfirmingId] = useState(null);
  const [addError, setAddError] = useState("");
  const extras=data[activeMonth].extras, bycat={};
  extras.forEach(e=>{ if(e.cat) bycat[e.cat]=(bycat[e.cat]||0)+(e.monto||0); });

  // Categorías disponibles: usar las del usuario si están, sino fallback a CATS
  const catOpciones = categorias && categorias.length > 0
    ? categorias.filter(c => c.activa !== false).map(c => c.nombre)
    : CATS;

  const add=()=>{
    setAddError("");
    setPresupuestos([...presupuestos,{id:crypto.randomUUID(),cat:"",limite:0}]);
  };
  const upd=(id,f)=>{
    const nuevo={...presupuestos.find(p=>p.id===id),...f};
    // Validar duplicado al cambiar cat
    if(f.cat){
      const dup=presupuestos.find(p=>p.id!==id&&p.cat===f.cat);
      if(dup){ setAddError("Ya existe un presupuesto para esa categoría"); setTimeout(()=>setAddError(""),3000); return; }
    }
    setPresupuestos(presupuestos.map(p=>p.id===id?{...p,...f}:p));
  };
  const del=(id)=>setPresupuestos(presupuestos.filter(p=>p.id!==id));

  // Empty state: todavía no hay presupuestos definidos
  if (presupuestos.length === 0) {
    return (
      <EmptyState
        icon="📊"
        title="Aún no tienes presupuestos"
        desc="Define cuánto vas a gastar en cada categoría y Arbo te avisa antes de pasarte."
        btnLabel="Crear mi primer presupuesto"
        onBtn={add}
        token={P.ingresos}
      />
    );
  }

  return (
    <Card style={{ marginBottom:16 }}>
      <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:6 }}>
        <span style={{ fontSize:18 }}>🎯</span>
        <Heading>Presupuesto por categoría</Heading>
      </div>
      <p style={{ fontSize:12, color:P.textSm, fontFamily:FF, marginBottom:20, marginTop:-12 }}>Define el gasto máximo por categoría y recibe alertas.</p>
      {addError && (
        <div style={{ background:"#FEF2F2", border:"1px solid #FCA5A5", borderRadius:8, padding:"8px 12px", marginBottom:12, fontSize:12, color:"#DC2626", fontFamily:FF, fontWeight:600 }}>
          {addError}
        </div>
      )}
      {presupuestos.map(p=>{
        const gasto=bycat[p.cat]||0, pct=p.limite>0?Math.min(gasto/p.limite*100,100):0;
        const barColor=pct>=100?P.danger.mid:pct>=70?P.warn.mid:P.ingresos.mid;
        return (
          <div key={p.id} style={{ marginBottom:18, paddingBottom:18, borderBottom:`1px solid ${P.border}` }}>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 130px auto", gap:8, alignItems:"center", marginBottom:p.cat&&p.limite>0?10:0 }}>
              <select value={p.cat} onChange={e=>upd(p.id,{cat:e.target.value})} style={{ ...inputBase, fontSize:13 }}>
                <option value="">Categoría…</option>
                {catOpciones.map(c=><option key={c} value={c}>{c}</option>)}
              </select>
              <div style={{ position:"relative" }}>
                <span style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)", color:P.textXs, fontSize:12 }}>$</span>
                <MoneyInput aria-label="Limite mensual del presupuesto" value={p.limite} onChange={v=>upd(p.id,{limite:v})} placeholder="Límite"
                  style={{ ...inputBase, paddingLeft:24, fontWeight:700 }} />
              </div>
              {confirmingId === p.id ? (
                <div style={{ display:"flex", gap:4, alignItems:"center" }}>
                  <span style={{ fontSize:11, fontWeight:600, color:"#991B1B" }}>¿Seguro?</span>
                  <button onClick={()=>{ del(p.id); setConfirmingId(null); }}
                    aria-label="Confirmar eliminar"
                    style={{ width:44, height:44, borderRadius:12, border:"1.5px solid #FECACA", background:"#FEF2F2", color:"#DC2626", fontSize:13, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>✓</button>
                  <button onClick={()=>setConfirmingId(null)}
                    aria-label="Cancelar"
                    style={{ width:44, height:44, borderRadius:12, border:"1.5px solid #E5E7EB", background:"#F3F4F6", color:"#6B7280", fontSize:13, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>✕</button>
                </div>
              ) : (
                <button onClick={()=>setConfirmingId(p.id)} style={{ width:44, height:44, borderRadius:12, border:`1.5px solid ${P.border}`, background:"transparent", color:P.textXs, cursor:"pointer", fontSize:15, display:"flex", alignItems:"center", justifyContent:"center" }}>×</button>
              )}
            </div>
            {p.cat&&p.limite>0&&(
              <>
                <div style={{ height:6, background:P.bg, borderRadius:99, marginBottom:6, overflow:"hidden" }}>
                  <div style={{ height:"100%", borderRadius:99, background:barColor, width:`${pct}%`, transition:"width .4s ease" }} />
                </div>
                <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:P.textXs, fontFamily:FF }}>
                  <span>Gastado: <strong style={{ fontWeight:700, color:P.textMd }}>{fmt(gasto)}</strong></span>
                  <span>Disponible: <strong style={{ fontWeight:700, color:P.textMd }}>{fmt(Math.max(p.limite-gasto,0))}</strong></span>
                </div>
              </>
            )}
          </div>
        );
      })}
      <button onClick={add} style={{ border:`1.5px dashed ${P.borderMd}`, borderRadius:10, background:"transparent", color:P.textSm, cursor:"pointer", padding:"8px 16px", fontSize:12, fontFamily:FF, fontWeight:600 }}>
        + Agregar categoría
      </button>
    </Card>
  );
}
